import React from 'react';


function VisualizarArtigo() {
  return <div style={{ padding: 30}}>Em breve... sério... em 3 dias!</div>;
}

export default VisualizarArtigo;